import { getBaseRole } from '@/helpers/customRoles';
export const STUDENT_PROFILE_FIELDS_SETTINGS_KEY =
  'studentProfileFieldsSettings'

export const STUDENT_CUSTOM_FIELDS_SETTING_KEY = 'customFieldsChild'

export const STUDENT_UNIVERSITY2035_SETTING_KEY = 'isShowUniversity2035Child'

export const STUDENT_AGE_INPUT_TOOLTIP =
  'В поле "Возраст" нельзя ничего вписать. Впишите дату рождения, и тогда возраст подтянется автоматически'

export const STUDENT_FIELD_TYPES = {
  TEXT: 'textfield',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  SELECT: 'select',
  DATE: 'date',
  PHONE: 'phone_number',
  LINK: 'link',
  TECHNICAL: 'technical',
}

export const STUDENT_FIELD_TYPE_OPTIONS = [
  { label: 'Малое текстовое поле', value: STUDENT_FIELD_TYPES.TEXT },
  { label: 'Большое текстовое поле', value: STUDENT_FIELD_TYPES.TEXTAREA },
  { label: 'Числовое поле', value: STUDENT_FIELD_TYPES.NUMBER },
  { label: 'Список', value: STUDENT_FIELD_TYPES.SELECT },
  { label: 'Дата', value: STUDENT_FIELD_TYPES.DATE },
  { label: 'Телефон', value: STUDENT_FIELD_TYPES.PHONE },
  { label: 'Ссылка', value: STUDENT_FIELD_TYPES.LINK },
]

export const STUDENT_FIELD_TYPE_LABELS = {
  [STUDENT_FIELD_TYPES.TEXT]: 'Малое текстовое',
  [STUDENT_FIELD_TYPES.TEXTAREA]: 'Большое текстовое',
  [STUDENT_FIELD_TYPES.NUMBER]: 'Числовое поле',
  [STUDENT_FIELD_TYPES.SELECT]: 'Список',
  [STUDENT_FIELD_TYPES.DATE]: 'Дата',
  [STUDENT_FIELD_TYPES.PHONE]: 'Телефон',
  [STUDENT_FIELD_TYPES.LINK]: 'Ссылка',
  [STUDENT_FIELD_TYPES.TECHNICAL]: 'Техническое',
}

export const STUDENT_PROFILE_SYSTEM_FIELDS = [
  {
    id: 'name',
    label: 'ФИО',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'name',
    activeLocked: true,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: false,
  },
  {
    id: 'phone',
    label: 'Номер телефона',
    type: STUDENT_FIELD_TYPES.PHONE,
    valueKey: 'phone',
    activeSetting: 'isShowPhoneChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: false,
  },
  {
    id: 'email',
    label: 'Почта',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'email',
    activeSetting: 'isShowEmailChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: false,
  },
  {
    id: 'login',
    label: 'Логин',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'login',
    defaultActive: false,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'parents',
    label: 'Родители',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    defaultActive: false,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
  },
  {
    id: 'classes',
    label: 'Классы/образовательные траектории',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowClassesChild',
    defaultActive: true,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
    tooltip:
      'Если отключить данное поле, то вы не сможете добавлять учащимся какие-либо конкретные классы/обр.траектории, созданные на платформе.',
  },
  {
    id: 'courses',
    label: 'Курсы',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowCoursesChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
    tooltip:
      'Если отключить данное поле, то вы не сможете добавлять учащимся какие-либо конкретные курсы, созданные на платформе.',
  },
  {
    id: 'agreements',
    label: 'Договоры',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowAgreementsChild',
    defaultActive: true,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
    tooltip:
      'Если отключить данное поле, то вы, учащиеся и родители не смогут загружать договоры и другие документы в карточку учащегося.',
  },
  {
    id: 'studentCardLink',
    label: 'Ссылка на карточку ученика',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowStudentCardLinkChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
  },
  {
    id: 'paymentLink',
    label: 'Ссылка на продление обучения',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowPaymentLinkChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: false,
    tooltip:
      'В этом поле находится уникальная ссылка для каждого учащегося. Перейдя по ней, он (или его родитель) может оплатить свое обучение и продлить его, даже если он будет не авторизован в системе.',
  },
  {
    id: 'gamificationExperience',
    label: 'Опыт',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowGamificationExperienceChild',
    defaultActive: true,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: false,
  },
  {
    id: 'gamificationBalance',
    label: 'Игровая валюта',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'isShowGamificationBalanceChild',
    defaultActive: true,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: false,
  },
  {
    id: 'referralBalance',
    label: 'Реферальный баланс',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    valueKey: 'referral_balance',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: false,
  },
  {
    id: 'university2035',
    label: 'У2035',
    type: STUDENT_FIELD_TYPES.TECHNICAL,
    activeSetting: STUDENT_UNIVERSITY2035_SETTING_KEY,
    defaultActive: false,
    canRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
    canRoleVisible: false,
  },
  {
    id: 'id',
    label: 'ID',
    type: STUDENT_FIELD_TYPES.NUMBER,
    activeSetting: 'isShowIdChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: false,
  },
  {
    id: 'sex',
    label: 'Пол',
    type: STUDENT_FIELD_TYPES.SELECT,
    valueKey: 'sex',
    activeSetting: 'isShowGenderChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'birthDate',
    label: 'Дата рождения',
    type: STUDENT_FIELD_TYPES.DATE,
    valueKey: 'birth_date',
    activeSetting: 'isShowDateOfBirthChild',
    defaultActive: false,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'age',
    label: 'Возраст',
    type: STUDENT_FIELD_TYPES.NUMBER,
    valueKey: 'age',
    activeSetting: 'isShowClassChild',
    defaultActive: false,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: false,
    defaultProfileEditable: false,
    tooltip:
      'Возраст рассчитывается автоматически по полю «Дата рождения». Ввести возраст вручную нельзя.',
  },
  {
    id: 'promo',
    label: 'Реф.Промокод',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'promo_code',
    activeSetting: 'isShowPromoChild',
    defaultActive: false,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: false,
  },
  {
    id: 'socialLink',
    label: 'Ссылка на соцсеть',
    type: STUDENT_FIELD_TYPES.LINK,
    valueKey: 'link_to_vk',
    activeSetting: 'isShowLinkToSocialMediaNetChild',
    defaultActive: false,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'city',
    label: 'Город',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'city',
    activeSetting: 'isShowCityChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'pointer',
    label: 'Указатель',
    type: STUDENT_FIELD_TYPES.TEXT,
    valueKey: 'custom_id',
    activeSetting: 'isShowPointerChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: false,
  },
  {
    id: 'timezone',
    label: 'Часовой пояс',
    type: STUDENT_FIELD_TYPES.NUMBER,
    valueKey: 'timezone',
    activeSetting: 'isShowTimeZoneChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'about',
    label: 'О себе',
    type: STUDENT_FIELD_TYPES.TEXTAREA,
    valueKey: 'about',
    activeSetting: 'isShowAboutMeChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'aboutStudent',
    label: 'Об ученике (Не видно учащемуся)',
    type: STUDENT_FIELD_TYPES.TEXTAREA,
    valueKey: 'about_student',
    activeSetting: 'isShowAboutChild',
    defaultActive: true,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
  },
]

export const STUDENT_PARENT_FIELDS = [
  {
    id: 'parentName',
    label: 'Имена родителей',
    type: STUDENT_FIELD_TYPES.TEXT,
    activeSetting: 'isShowParentNameChild',
    defaultActive: false,
  },
  {
    id: 'parentEmail',
    label: 'Email родителей',
    type: STUDENT_FIELD_TYPES.TEXT,
    activeSetting: 'isShowParentEmailChild',
    defaultActive: false,
  },
  {
    id: 'parentPhone',
    label: 'Телефоны родителей',
    type: STUDENT_FIELD_TYPES.PHONE,
    activeSetting: 'isShowParentPhoneChild',
    defaultActive: false,
  },
]

const STUDENT_API_FIELD_ID_BY_NAME = {
  name: 'name',
  phone: 'phone',
  email: 'email',
  login: 'login',
  parents: 'parents',
  classes: 'classes',
  courses: 'courses',
  agreements: 'agreements',
  student_card_link: 'studentCardLink',
  payment_link: 'paymentLink',
  gamification_experience: 'gamificationExperience',
  gamification_balance: 'gamificationBalance',
  referral_balance: 'referralBalance',
  university2035: 'university2035',
  university_2035: 'university2035',
  id: 'id',
  sex: 'sex',
  birth_date: 'birthDate',
  learning_class: 'age',
  promo_code: 'promo',
  link_to_vk: 'socialLink',
  city: 'city',
  custom_id: 'pointer',
  timezone: 'timezone',
  about: 'about',
  about_student: 'aboutStudent',
  parent_name: 'parentName',
  parent_email: 'parentEmail',
  parent_phone: 'parentPhone',
}

const STUDENT_SYSTEM_FIELD_BY_ID = [
  ...STUDENT_PROFILE_SYSTEM_FIELDS,
  ...STUDENT_PARENT_FIELDS,
].reduce((acc, field) => {
  acc[field.id] = field
  return acc
}, {})

export const isTruthySetting = (value, fallback = false) => {
  if (value === undefined || value === null) return fallback
  return value === true || value === '1' || value === 1
}

export const canViewStudentUniversity2035 = (
  integrationEnabled = false,
  profileFieldEnabled = false,
  role,
) => getBaseRole(role) === 'admin' || (integrationEnabled && profileFieldEnabled)

const safeJsonParse = (value, fallback) => {
  if (Array.isArray(value) || (value && typeof value === 'object')) return value
  if (!value || typeof value !== 'string') return fallback

  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const getFiniteNumber = (value, fallback) => {
  if (value === undefined || value === null || value === '') return fallback
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export const parseStudentFieldSettings = (value) => {
  const parsed = safeJsonParse(value, {})

  return {
    required:
      parsed?.required && typeof parsed.required === 'object'
        ? parsed.required
        : {},
    profileVisible:
      parsed?.profileVisible && typeof parsed.profileVisible === 'object'
        ? parsed.profileVisible
        : {},
    profileEditable:
      parsed?.profileEditable && typeof parsed.profileEditable === 'object'
        ? parsed.profileEditable
        : {},
    employeeVisible:
      parsed?.employeeVisible && typeof parsed.employeeVisible === 'object'
        ? parsed.employeeVisible
        : {},
    salesManagerVisible:
      parsed?.salesManagerVisible &&
      typeof parsed.salesManagerVisible === 'object'
        ? parsed.salesManagerVisible
        : {},
    teacherVisible:
      parsed?.teacherVisible && typeof parsed.teacherVisible === 'object'
        ? parsed.teacherVisible
        : {},
    sorting:
      parsed?.sorting && typeof parsed.sorting === 'object'
        ? parsed.sorting
        : {},
  }
}

export const serializeStudentFieldSettings = (settings) =>
  JSON.stringify(parseStudentFieldSettings(settings))

export const normalizeStudentCustomField = (field, index = 0) => {
  const rawType = field?.type ?? STUDENT_FIELD_TYPES.TEXT
  const type = Object.values(STUDENT_FIELD_TYPES).includes(rawType)
    ? rawType
    : STUDENT_FIELD_TYPES.TEXT
  const fallbackName = `custom_${Date.now()}_${index}`

  return {
    id: field?.id ?? field?.name ?? fallbackName,
    name: String(field?.name ?? fallbackName),
    label: String(field?.label ?? field?.name ?? ''),
    type,
    value_options: Array.isArray(field?.value_options)
      ? field.value_options
      : Array.isArray(field?.fields)
        ? field.fields.map((item) => item?.label ?? item?.name).filter(Boolean)
        : [],
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.required ?? field?.is_required, false),
    profile_visible: isTruthySetting(field?.profile_visible, false),
    profile_editable:
      isTruthySetting(field?.profile_visible, false) &&
      isTruthySetting(field?.profile_editable, false),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(
      field?.sales_manager_visible,
      true,
    ),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? null
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: true,
    is_system: false,
    can_active: isTruthySetting(field?.can_active, true),
    can_required: isTruthySetting(field?.can_required, true),
    can_profile_visible: isTruthySetting(field?.can_profile_visible, true),
    can_profile_editable: isTruthySetting(field?.can_profile_editable, true),
  }
}

const normalizeStudentSystemField = (field, index = 0) => {
  const systemId =
    STUDENT_API_FIELD_ID_BY_NAME[field?.name] ??
    STUDENT_API_FIELD_ID_BY_NAME[field?.id] ??
    field?.name ??
    field?.id
  const baseField = STUDENT_SYSTEM_FIELD_BY_ID[systemId]
  const isAgeField = systemId === 'age'

  if (!baseField) return null

  return {
    ...baseField,
    profileFieldId: field.id,
    fieldName: field.name,
    label:
      systemId === 'promo'
        ? baseField.label
        : String(field?.label ?? baseField.label),
    type: field?.type ?? baseField.type,
    value_options: field?.value_options ?? baseField.value_options,
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.is_required, baseField.defaultRequired),
    profile_visible: isTruthySetting(
      field?.profile_visible,
      baseField.defaultProfileVisible,
    ),
    profile_editable:
      !isAgeField &&
      isTruthySetting(field?.profile_visible, baseField.defaultProfileVisible) &&
      isTruthySetting(field?.profile_editable, baseField.defaultProfileEditable),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(field?.sales_manager_visible, true),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    can_active: isTruthySetting(field?.can_active, Boolean(baseField.activeSetting)),
    can_required: isTruthySetting(field?.can_required, baseField.canRequired),
    can_profile_visible: isTruthySetting(
      field?.can_profile_visible,
      baseField.canProfileVisible,
    ),
    can_profile_editable:
      !isAgeField &&
      isTruthySetting(field?.can_profile_editable, baseField.canProfileEditable),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? index + 1
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: false,
    is_system: true,
  }
}

export const parseStudentCustomFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return []

  return parsed
    .filter((field) => !field?.is_system)
    .map(normalizeStudentCustomField)
}

export const parseStudentProfileApiFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return { systemFields: [], customFields: [] }

  return parsed.reduce(
    (acc, field, index) => {
      if (field?.is_system) {
        const systemField = normalizeStudentSystemField(field, index)
        if (systemField) acc.systemFields.push(systemField)
        return acc
      }

      acc.customFields.push(normalizeStudentCustomField(field, index))
      return acc
    },
    { systemFields: [], customFields: [] },
  )
}

export const serializeStudentCustomFields = (fields) =>
  JSON.stringify(parseStudentCustomFields(fields))

export const getStudentFieldTypeLabel = (type) =>
  STUDENT_FIELD_TYPE_LABELS[type] ?? 'Малое текстовое'

export const getStudentFieldDefaultActive = (field) =>
  field?.defaultActive ?? true

export const getStudentFieldSettingValue = (field, settings, key) => {
  if (!field) return false

  const safeSettings = {
    ...settings,
    required: settings?.required ?? {},
    profileVisible: settings?.profileVisible ?? {},
    profileEditable: settings?.profileEditable ?? {},
    employeeVisible: settings?.employeeVisible ?? {},
    salesManagerVisible: settings?.salesManagerVisible ?? {},
    teacherVisible: settings?.teacherVisible ?? {},
  }

  if (field.profileFieldId || field.is_system) {
    if (key === 'required') return isTruthySetting(field.required)
    if (key === 'profileVisible') return isTruthySetting(field.profile_visible)
    if (key === 'profileEditable')
      return (
        isTruthySetting(field.profile_visible) &&
        isTruthySetting(field.profile_editable)
      )
    if (key === 'employeeVisible') return isTruthySetting(field.employee_visible, true)
    if (key === 'salesManagerVisible')
      return isTruthySetting(field.sales_manager_visible, true)
    if (key === 'teacherVisible') return isTruthySetting(field.teacher_visible, true)
    return false
  }

  if (field.isCustom) {
    if (key === 'required') return isTruthySetting(field.required)
    if (key === 'profileVisible') return isTruthySetting(field.profile_visible)
    if (key === 'profileEditable')
      return (
        isTruthySetting(field.profile_visible) &&
        isTruthySetting(field.profile_editable)
      )
    if (key === 'employeeVisible')
      return isTruthySetting(field.employee_visible, true)
    if (key === 'salesManagerVisible')
      return isTruthySetting(field.sales_manager_visible, true)
    if (key === 'teacherVisible')
      return isTruthySetting(field.teacher_visible, true)
    return false
  }

  if (key === 'required') {
    if (!field.canRequired) return false
    return isTruthySetting(safeSettings.required[field.id], field.defaultRequired)
  }

  if (key === 'profileVisible') {
    if (!field.canProfileVisible) return false
    return isTruthySetting(
      safeSettings.profileVisible[field.id],
      field.defaultProfileVisible,
    )
  }

  if (key === 'profileEditable') {
    if (!field.canProfileEditable) return false
    return (
      getStudentFieldSettingValue(field, safeSettings, 'profileVisible') &&
      isTruthySetting(
        safeSettings.profileEditable[field.id],
        field.defaultProfileEditable,
      )
    )
  }

  if (key === 'employeeVisible') {
    return isTruthySetting(safeSettings.employeeVisible[field.id], true)
  }

  if (key === 'salesManagerVisible') {
    return isTruthySetting(safeSettings.salesManagerVisible[field.id], true)
  }

  if (key === 'teacherVisible') {
    return isTruthySetting(safeSettings.teacherVisible[field.id], true)
  }

  return false
}

export const isStudentFieldActive = (field, platformSettings) => {
  if (field.activeLocked) return true
  if (field.useActiveSetting && field.activeSetting) {
    return isTruthySetting(
      platformSettings?.[field.activeSetting],
      getStudentFieldDefaultActive(field),
    )
  }
  if (field.profileFieldId || field.is_system)
    return isTruthySetting(field.is_active, true)
  if (field.isCustom) return isTruthySetting(field.is_active, true)
  if (!field.activeSetting) return true
  return isTruthySetting(
    platformSettings?.[field.activeSetting],
    getStudentFieldDefaultActive(field),
  )
}

export const getStudentProfileVisibilityKeyByRole = (role) => {
  if (['personal-manager', 'hr-manager'].includes(getBaseRole(role))) {
    return 'employee_visible'
  }

  if (getBaseRole(role) === 'sales-manager') {
    return 'sales_manager_visible'
  }

  if (['seminarian', 'senior-seminarian'].includes(getBaseRole(role))) {
    return 'teacher_visible'
  }

  return null
}

export const isStudentProfileFieldVisibleForRole = (field, role) => {
  const key = getStudentProfileVisibilityKeyByRole(role)
  if (!key) return true

  return isTruthySetting(field?.[key], true)
}

export const hasStudentProfileVisibleFieldsForRole = (
  platformSettings = {},
  role,
  customFieldsSource = undefined,
) => {
  const key = getStudentProfileVisibilityKeyByRole(role)
  if (!key) return true

  return getStudentProfileFields(platformSettings, customFieldsSource).some(
    (field) => isStudentProfileFieldVisibleForRole(field, role),
  )
}

export const isStudentProfileTeacherRole = (role) =>
  ['seminarian', 'senior-seminarian'].includes(getBaseRole(role))

export const isTextareaStudentField = (field) =>
  field.type === STUDENT_FIELD_TYPES.TEXTAREA

export const getStudentProfileFields = (
  platformSettings = {},
  customFieldsSource,
  includeInactive = false,
) => {
  const settings = platformSettings ?? {}
  const fieldSettings = parseStudentFieldSettings(
    settings[STUDENT_PROFILE_FIELDS_SETTINGS_KEY],
  )
  const apiFields = parseStudentProfileApiFields(customFieldsSource)
  const customFields = customFieldsSource
    ? apiFields.customFields
    : parseStudentCustomFields(settings[STUDENT_CUSTOM_FIELDS_SETTING_KEY])
  const fallbackSystemFields = STUDENT_PROFILE_SYSTEM_FIELDS.map((field) => ({
    ...field,
    isCustom: false,
  }))
  const systemFields = apiFields.systemFields.length
    ? [
        ...apiFields.systemFields,
        ...fallbackSystemFields.filter(
          (field) =>
            field.id === 'university2035' &&
            !apiFields.systemFields.some((item) => item.id === field.id),
        ),
      ]
    : fallbackSystemFields
  const parentFieldsFromApi = apiFields.systemFields.filter((field) =>
    STUDENT_PARENT_FIELDS.some((item) => item.id === field.id),
  )
  const parentFields = parentFieldsFromApi.length
    ? parentFieldsFromApi
    : STUDENT_PARENT_FIELDS.map((field) => ({
        ...field,
        isCustom: false,
      }))
  const allFields = [
    ...systemFields.filter(
      (field) => !STUDENT_PARENT_FIELDS.some((item) => item.id === field.id),
    ),
    ...parentFields,
    ...customFields,
  ]
  let regularSorting = 0
  let textAreaSorting = 0

  return allFields
    .filter(
      (field) => includeInactive || isStudentFieldActive(field, platformSettings),
    )
    .map((field) => {
      const fallbackSorting = isTextareaStudentField(field)
        ? (textAreaSorting += 1)
        : (regularSorting += 1)

      return {
        ...field,
        defaultSorting: fallbackSorting,
        sorting: field.isCustom
          ? getFiniteNumber(field.sorting, fallbackSorting)
          : field.profileFieldId || field.is_system
            ? getFiniteNumber(field.sorting, fallbackSorting)
            : getFiniteNumber(
                fieldSettings.sorting[field.id],
                fallbackSorting,
              ),
        required: getStudentFieldSettingValue(field, fieldSettings, 'required'),
        profile_visible: getStudentFieldSettingValue(
          field,
          fieldSettings,
          'profileVisible',
        ),
        profile_editable: getStudentFieldSettingValue(
          field,
          fieldSettings,
          'profileEditable',
        ),
        employee_visible: getStudentFieldSettingValue(
          field,
          fieldSettings,
          'employeeVisible',
        ),
        sales_manager_visible: getStudentFieldSettingValue(
          field,
          fieldSettings,
          'salesManagerVisible',
        ),
        teacher_visible: getStudentFieldSettingValue(
          field,
          fieldSettings,
          'teacherVisible',
        ),
      }
    })
    .sort((a, b) => {
      const aTextarea = isTextareaStudentField(a)
      const bTextarea = isTextareaStudentField(b)
      if (aTextarea !== bTextarea) return aTextarea ? 1 : -1
      return Number(a.sorting ?? a.defaultSorting) - Number(b.sorting ?? b.defaultSorting)
    })
}

export const getStudentCustomFieldValues = (student = {}) => {
  const source = student ?? {}
  const value =
    source.custom_fields ??
    source.userProfile?.custom_fields ??
    source.userProfile?.customFields ??
    {}
  const parsed = safeJsonParse(value, {})

  return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
    ? parsed
    : {}
}

export const isValidStudentLinkValue = (value) => {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) return true

  try {
    const url = new URL(
      /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`,
    )
    return Boolean(url.hostname && url.hostname.includes('.'))
  } catch {
    return false
  }
}
